import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Chip } from "@mui/material";
import { useState } from "react";

import {
  AutoCompleteUncontrolled,
  ISelectType,
  ModalFilters,
  Table,
} from "@4uhub/lib4uhub";

import MainApiService from "../../../../services/mainApi.service";
import { IGetSiteLoginContents } from "../../../../models/site-login-content";

const SITE_LOGIN_CONTENT_ROUTE =
  process.env.REACT_APP_MAIN + "/api/v1/SiteLoginContent/";
const siteLoginContentService = new MainApiService<IGetSiteLoginContents>(
  SITE_LOGIN_CONTENT_ROUTE
);

const translationPath = "page.4uSiteApp.siteLoginContent.";

const SiteLoginContentPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [status, setStatus] = useState<ISelectType | null>(null);

  const [filterParams, setFilterParams] = useState<Record<string, any>>();

  const filterHandler = () => {
    setFilterParams({
      Enable: status ? (status.id === "1" ? true : false) : undefined,
    });
  };

  const cleanFilterHandler = () => {
    setFilterParams(undefined);
    setStatus(null);
  };

  const columns: GridColDef<IGetSiteLoginContents>[] = [
    {
      field: "name",
      headerName: t(translationPath + "name") || "Name",
    },
    {
      field: "presentationOrder",
      headerName:
        t(translationPath + "presentation_order") || "Presentation order",
    },
    {
      field: "linkUrl",
      headerName: t(translationPath + "link_url") || "Link",
    },
    {
      field: "enable",
      headerName: t(translationPath + "enable") || "Enable",
      renderCell: (params) => {
        return (
          <Chip
            size="small"
            label={
              params.value
                ? t(translationPath + "active")
                : t(translationPath + "inactive")
            }
            color={params.value ? "success" : "error"}
          />
        );
      },
    },
  ];

  const handleAdd = () => {
    navigate("new");
  };

  const handleRowClick = (params: GridRowParams<IGetSiteLoginContents>) => {
    navigate(`${params.id.toString()}/edit`);
  };

  return (
    <Table<IGetSiteLoginContents>
      showDefaultMacroFilters={false}
      service={siteLoginContentService}
      columns={columns}
      title={t(translationPath + "site_login_content")}
      searchInput
      onAdd={handleAdd}
      getRowHeight={() => "auto"}
      onRowClick={handleRowClick}
      defaultActions={false}
      serviceProps={filterParams}
      searchInputPlaceHolder={
        t(translationPath + "search") || "Search for a login content"
      }
      macroFilters={() => (
        <ModalFilters
          actionsDisabled={!status}
          badgeCount={
            filterParams
              ? Object.keys(filterParams).filter(
                  (key) => filterParams[key] !== undefined
                ).length
              : 0
          }
          onCleanFilter={cleanFilterHandler}
          onFilter={filterHandler}
        >
          <AutoCompleteUncontrolled
            value={status}
            onValueSelected={setStatus}
            label={t(translationPath + "status")}
            size="small"
            options={[
              { id: "1", name: t(translationPath + "active") },
              { id: "2", name: t(translationPath + "inactive") },
            ]}
          />
        </ModalFilters>
      )}
      addButtonLabel={
        t(translationPath + "add_site_login_content") || "Add login content"
      }
      confirmOptions={{
        title: t(translationPath + "confirm.title"),
        description: t(translationPath + "confirm.description"),
        confirmationButtonProps: {
          variant: "contained",
        },
      }}
    />
  );
};

export default SiteLoginContentPage;
